var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWarningFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.81,12.9c102.72-.33,187,83.48,187.26,186.29.23,103.05-81.78,186.47-184.42,187.89-104,1.45-188.92-81.4-189.72-185.25A186.77,186.77,0,0,1,199.81,12.9Zm.52,62.38c-28.09.06-49.44,26.52-42.88,53.91,9.93,41.48,20.38,82.83,30.66,124.22,1.64,6.61,6.34,10.49,12.28,10.48s10.66-3.84,12.3-10.47c10.25-41.53,20.67-83,30.54-124.64C249.69,101.55,228.23,75.22,200.33,75.28Zm-.05,215.89a24.94,24.94,0,1,0-.45,49.88,25.13,25.13,0,0,0,25.07-24.58A24.85,24.85,0,0,0,200.28,291.17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarningFill);
export default __webpack_public_path__ + "static/media/Icons_Warning Fill.13b6658d16edf4fea7ec620d9f4753c1.svg";
export { ForwardRef as ReactComponent };